export default {
  light: 'light',
  dark: 'dark',
  system: 'system'
}
